export const IDB_NAME = 'quest-editor-db';
export const IDB_VERSION = 3;
